import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const RightsOfUser = () => {
  const classes = useStyles()
  return (
    <Box className={'section'}>
      <Typography variant="h4">The rights of Users</Typography>
      <Typography variant="body1">
        Users may exercise certain rights regarding their Data processed by the
        Owner.
      </Typography>
      <Typography variant="body1">
        In particular, Users have the right to do the following:
      </Typography>

      <Box component="ul" className={classes.listContainer}>
        <Typography variant="body1" component="li">
          <Typography component="span">
            Withdraw their consent at any time.
          </Typography>
          Users have the right to withdraw consent where they have previously
          given their consent to the processing of their Personal Data.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">
            Object to processing of their Data.
          </Typography>
          Users have the right to object to the processing of their Data if the
          processing is carried out on a legal basis other than consent. Further
          details are provided in the dedicated section below.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">Access their Data. </Typography>Users
          have the right to learn if Data is being processed by the Owner,
          obtain disclosure regarding certain aspects of the processing and
          obtain a copy of the Data undergoing processing.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">
            Verify and seek rectification.{' '}
          </Typography>
          Users have the right to verify the accuracy of their Data and ask for
          it to be updated or corrected.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">
            Restrict the processing of their Data.
          </Typography>
          Users have the right, under certain circumstances, to restrict the
          processing of their Data. In this case, the Owner will not process
          their Data for any purpose other than storing it.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">
            Have their Personal Data deleted or otherwise removed.
          </Typography>
          Users have the right, under certain circumstances, to obtain the
          erasure of their Data from the Owner.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">
            Receive their Data and have it transferred to another controller.{' '}
          </Typography>
          Users have the right to receive their Data in a structured, commonly
          used and machine readable format and, if technically feasible, to have
          it transmitted to another controller without any hindrance. This
          provision is applicable provided that the Data is processed by
          automated means and that the processing is based on the User's
          consent, on a contract which the User is part of or on pre-contractual
          obligations thereof.
        </Typography>

        <Typography variant="body1" component="li">
          <Typography component="span">Lodge a complaint. </Typography>
          Users have the right to bring a claim before their competent data
          protection authority.
        </Typography>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    listContainer: {
      '&>li>span': {
        fontWeight: '700'
      }
    }
  })
)

export default RightsOfUser
